import { CALL_API } from '../../api';
import * as ActionTypes from './costEstimate.actionTypes';
import schema from '../../api/schema';

const apiCreateCostEstimate = data => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_COSTESTIMATE_REQUEST,
      ActionTypes.CREATE_COSTESTIMATE_SUCCESS,
      ActionTypes.CREATE_COSTESTIMATE_FAILURE,
    ],
    endpoint: 'costestimate',
    schema: schema.costEstimateSchema,
    authorization: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data),
    },
  },
});

export const createCostEstimate = data => (dispatch, getState) => {
  return dispatch(apiCreateCostEstimate(data));
};

const apiUpdateCostEstimate = data => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_COSTESTIMATE_REQUEST,
      ActionTypes.UPDATE_COSTESTIMATE_SUCCESS,
      ActionTypes.UPDATE_COSTESTIMATE_FAILURE,
    ],
    endpoint: `costestimate/${data._id}`,
    schema: schema.costEstimatesSchema,
    authorization: true,
    requestInit: {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data),
    },
  },
  payload: {
    id: data._id,
  },
});

export const updateCostEstimate = data => (dispatch, getState) => {
  return dispatch(apiUpdateCostEstimate(data));
};

const apiReadCostEstimates = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_COSTESTIMATE_REQUEST,
      ActionTypes.READ_COSTESTIMATE_SUCCESS,
      ActionTypes.READ_COSTESTIMATE_FAILURE,
    ],
    endpoint: `costestimate/inspection/${id}`,
    schema: schema.costEstimatesSchema,
    authorization: true,
  },
});

export const readCostEstimates = id => (dispatch, getState) => {
  return dispatch(apiReadCostEstimates(id));
};



// WEBPACK FOOTER //
// ./src/modules/costEstimate/costEstimate.actions.js